import { createSlice } from '@reduxjs/toolkit';
import { _setStudentProfileLiveCourseData } from './studentProfileLiveCourseDataAction';

const initialState = {
  byStudentId: {},
};

export const studentProfileLiveCourseDataSlice = createSlice({
  name: 'delta/studentProfileLiveCourseData',
  initialState,
  reducers: {
    setStudentProfileLiveCourseData: _setStudentProfileLiveCourseData,
    resetStudentData: () => initialState,
  },
});

export const { setStudentProfileLiveCourseData, resetStudentData } =
  studentProfileLiveCourseDataSlice.actions;

export default studentProfileLiveCourseDataSlice.reducer;
